module.exports = __webpack_public_path__ + "resources/img/404-btm.f5879251.png";